export default "__VITE_ASSET__b98e10e5__"